import { z } from "zod";

export const PresenceEntityTypeValues = [
  "TICKET",
  "CONVERSATION",
  "TASK",
  "BID",
  "PROJECT",
  "CHECKLIST_QUESTION_REVIEW",
  "ESCALATION",
] as const;
export const PresenceEntityTypeSchema = z.enum(PresenceEntityTypeValues);
export const PresenceEntityType = PresenceEntityTypeSchema.enum;
export type PresenceEntityType = z.infer<typeof PresenceEntityTypeSchema>;

export type PresenceKey = { entityType: PresenceEntityType; entityId: string };

export type PresenceMap = Record<string, string[]>;

export const PresenceDataSchema = z.object({
  keys: z.array(z.string()),
  tabId: z.string(),
});

export type PresenceData = {
  keys: string[];
  tabId: string;
};
